import React from 'react';
import PropTypes from 'prop-types';
import { getCurrentUser } from '../../utils/RoleManager';
import { canAccess } from '../../constants/userRoles';

/**
 * Componente que protege conteúdo com base no papel do usuário.
 * Prefira `access` (área de ACCESS_AREAS, mesma régua do backend); `allowedRoles`
 * continua valendo para listas explícitas de papéis.
 * @param {Object} props - Propriedades do componente
 * @param {string} [props.access] - Área mínima ('financial', 'dataExport'...)
 * @param {Array<string>} [props.allowedRoles] - Papéis permitidos para acessar o conteúdo
 * @param {React.ReactNode} props.children - Conteúdo a ser protegido
 * @param {React.ReactNode} props.fallback - Conteúdo a ser exibido quando o acesso é negado
 * @returns {React.ReactNode} - Conteúdo protegido ou fallback
 */
function RoleGuard({ access, allowedRoles, children, fallback = null }) {
  const user = getCurrentUser();
  const allowed = access
    ? canAccess(user?.role, access)
    : Array.isArray(allowedRoles) && allowedRoles.includes(user?.role);
  return allowed ? children : fallback;
}

RoleGuard.propTypes = {
  access: PropTypes.string,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node
};

export default RoleGuard;